import React, { useState } from "react";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db, googleProvider } from "./firebase";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react"; 
import "./Register.css";
import EduConnectLogo from './logo.png';
import GoogleLogo from './gl.webp'; 

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [name, setName] = useState("");
  const [role, setRole] = useState("public_user"); 
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const userDocRef = doc(db, "users", user.uid);
      await setDoc(userDocRef, {
        uid: user.uid,
        name: name,
        email: email,
        userRole: role,
        createdAt: new Date(),
        status: "active"
      });

      setSuccess("Registration successful! Redirecting to login... 🎉");
      setEmail("");
      setPassword("");
      setName("");
      setRole("public_user");

      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (err) {
      const errorMessage = err.message.includes("Firebase:")
        ? err.message.split("Error (")[1].replace(/\)\./g, "").trim()
        : err.message;

      setError(errorMessage);
    }
  };

  const handleGoogleSignIn = async () => {
    setError("");
    setSuccess("");

    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      const userDocRef = doc(db, "users", user.uid);
      await setDoc(userDocRef, {
        uid: user.uid,
        name: user.displayName || "User",
        email: user.email,
        userRole: role,
        createdAt: new Date(),
        status: "active"
      }, { merge: true });

      setSuccess("Google Sign-In successful! Redirecting...");

      setTimeout(() => {
        navigate("/login");
      }, 1500);

    } catch (err) {
      const errorMessage = err.message.includes("Firebase:")
        ? err.message.split("Error (")[1].replace(/\)\./g, "").trim()
        : err.message;

      setError(errorMessage);
    }
  };

  const navigateToLogin = () => {
    navigate("/login");
  };

  return (
    <div className="register-container">
      
       <img src={EduConnectLogo} alt="EduConnect Logo" className="register-logo" /> 

      <h2 className="register-heading">Create Your Account</h2>

      <form onSubmit={handleRegister} className="register-form">
        <input
          type="text"
          placeholder="Full Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          className="register-input"
        />

        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="register-input"
        />

        {/* Password input box அளவில் மாற்றம் செய்யப்பட்டுள்ளது */}
        <div style={{ position: "relative", width: "100%", marginBottom: "15px" }}>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password (min 6 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="register-input"
            style={{ 
              width: "100%", 
              margin: "0", /* CSS margin-ஐ இங்கு கட்டுப்படுத்துகிறது */
              paddingRight: "45px",
              boxSizing: "border-box" 
            }}
          />
          <span 
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: "15px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              color: "#666",
              zIndex: "10"
            }}
          >
            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
          </span>
        </div>

        <button type="submit" className="register-button">
          Register
        </button>
      </form>
      
      <div className="or-separator">
        <hr className="separator-line" />
        <span className="separator-text">OR</span>
        <hr className="separator-line" />
      </div>

      <button onClick={handleGoogleSignIn} className="google-button">
        <img src={GoogleLogo} alt="Google Logo" className="google-icon" />
        Continue with Google
      </button>

      <p className="login-link-container">
        Already have an account?
        <span onClick={navigateToLogin} className="login-link">
          Click here to Login
        </span>
      </p>

      {error && <p className="message-error">❌ {error}</p>}
      {success && <p className="message-success">✅ {success}</p>}
    </div>
  );
}

export default Register;